let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fOB9Y")).then(() => parcelRequire('48wMp'));